import { on, each, addClass, removeClass } from '../helpers/shortcuts';
import shared from './shared';

export default () => {
  const teachers = document.querySelectorAll('.c-teachers');

  if (teachers.length < 1) {
    return;
  }

  each(teachers, teachersContainer => {
    const items = teachersContainer.querySelectorAll('.c-teachers__item');
    const anchor = teachersContainer.querySelector('.c-teachers__anchor');

    each(items, item => {
      const triggers = item.querySelectorAll('.js-trigger');

      each(triggers, trigger =>
        on('click', trigger, () => {
          const isActive = item.classList.contains(shared.CSS.active);

          if (shared.windowWidth >= shared.breakpoints.medium) {
            removeClass(items, shared.CSS.active);
          }

          if (!isActive) {
            addClass(item, shared.CSS.active);

            if (
              anchor !== null &&
              shared.windowWidth >= shared.breakpoints.medium
            ) {
              anchor.scrollIntoView({ behavior: 'smooth' });
            }
          } else {
            removeClass(item, shared.CSS.active);
          }
        }),
      );
    });
  });
};



// WEBPACK FOOTER //
// ./src/scripts/modules/teachers.js